import React, { FunctionComponent } from 'react'
import { Path, Svg } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

/**
 * Events Icon with calendar used for events navigation
 */
export const EventsIcon: FunctionComponent<EventsIconProps> = ({ size = 32, fillColor }) => {
  const { colors } = useTheme()
  return (
    <Svg width={size} height={size} viewBox='0 0 32 32' fill='none'>
      <Path
        d='M22.333 2.33325C22.8797 2.33325 23.333 2.78659 23.333 3.33325V5.66626H24C26.2132 5.66626 27.9998 7.45308 28 9.66626V25.6663C28 27.8796 26.2133 29.6663 24 29.6663H8C5.78667 29.6663 4 27.8796 4 25.6663V9.66626C4.00018 7.45308 5.78678 5.66626 8 5.66626H8.66699V3.33325C8.66699 2.78659 9.12033 2.33325 9.66699 2.33325C10.2135 2.33343 10.667 2.78669 10.667 3.33325V5.66626H21.333V3.33325C21.333 2.78669 21.7865 2.33343 22.333 2.33325ZM6 13.0002V25.6663C6 26.7729 6.89333 27.6663 8 27.6663H24C25.1067 27.6663 26 26.7729 26 25.6663V13.0002H6ZM11.999 21.6672V24.3333H9.33203V21.6672H11.999ZM17.335 21.6672V24.3333H14.668V21.6672H17.335ZM11.999 16.3333V19.0002H9.33203V16.3333H11.999ZM17.335 16.3333V19.0002H14.668V16.3333H17.335ZM22.667 16.3333V19.0002H20V16.3333H22.667ZM8 7.66626C6.89343 7.66626 6.00015 8.55972 6 9.66626V11.0002H26V9.66626C25.9998 8.55972 25.1066 7.66626 24 7.66626H8Z'
        fill={fillColor || colors.iconDefault}
      />
    </Svg>
  )
}

export type EventsIconProps = {
  size?: number
  fillColor?: string
}
